
import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

export default function SubclassIndex() {
  return (
    <FSIndex
      data_type="subclass"
      quick_fields={["game_class"]}
    />
  );
}
